import { TopProductCardsCarousel } from './TopProductCardsCarousel';
import { connect } from 'react-redux';

const mapStateToProps = (state: any) => ({
  isLoggedIn: state.signin.success
});

export default connect(mapStateToProps)(TopProductCardsCarousel);
